module.exports = __webpack_public_path__ + "static/demolition-pool_removal-d2707c9eae1b05fd35baa71289f27370.png";